import React from 'react';
import { useTranslation } from 'react-i18next';
import PopUp from '../../shared/PopUp/PopUp';
import { IconPro } from '../Icons';
import './ModalComparador.css';

interface ModalComparadorProps {
	isOpen: boolean;
	onClose: () => void;
	onViewPacks: () => void;
}

const ModalComparador: React.FC<ModalComparadorProps> = ({ isOpen, onClose, onViewPacks }) => {
	const { t } = useTranslation();

	return (
		<PopUp
			isOpen={isOpen}
			onClose={onClose}
			classes="popup-comparador">
			<div className="modal-comparador">
				<div className="modal-comparador__header">
					<h3 className="modal-comparador__title">
						<span>{t('modal_comparador.title')}</span>
						<span className="modal-comparador__title-icon">
							<IconPro fill="#1A2228" />
						</span>
					</h3>
					<p className="modal-comparador__message">{t('modal_comparador.message')}</p>
				</div>

				<div className="modal-comparador__body">
					<div className="modal-comparador__plans">
						<div className="modal-comparador__plans-left">
							<div className="modal-comparador__plans-left-header">
								<h3 className="modal-comparador__plans-left-title">
									{t('modal_comparador.title_pro')}
								</h3>
								<p className="modal-comparador__plans-left-subtitle">
									{t('modal_comparador.subtitle_pro')}
								</p>
							</div>

							<div className="modal-comparador__plans-left-content">
								<div className="modal-comparador__plan-item modal-comparador__plan-item--pro">
									<span className="modal-comparador__plan-label">
										<IconPro fill="white" />
										{t('modal_comparador.plan_pro.label')}
									</span>
									<div className="modal-comparador__plan-price">
										<span className="modal-comparador__plan-price-label">
											{t('modal_comparador.plan_pro.price')}
										</span>
										<span className="modal-comparador__plan-price-text">
											{t('modal_comparador.plan_pro.price_text')}
										</span>
									</div>
									<ul className="modal-comparador__plan-list">
										{[1, 2, 3, 4, 5, 6, 7].map((i) => (
											<li
												key={i}
												className="modal-comparador__plan-list-item">
												{t(`modal_comparador.plan_pro.list.item${i}`)}
											</li>
										))}
									</ul>
									<button
										className="modal-comparador__plan-link"
										onClick={onViewPacks}>
										{t('modal_comparador.plan_pro.link.title')}
									</button>
								</div>
							</div>
						</div>

						<div className="modal-comparador__plans-right">
							<div className="modal-comparador__plans-right-header">
								<h3 className="modal-comparador__plans-right-title">
									{t('modal_comparador.title_consultancy')}
								</h3>
							</div>
							<div className="modal-comparador__plans-right-content">
								<div className="modal-comparador__plan-item modal-comparador__plan-item--consultancy">
									<div className="modal-comparador__plan-price">
										<span className="modal-comparador__plan-price-label">
											{t('modal_comparador.plan_consultancy.price')}
										</span>
										<span className="modal-comparador__plan-price-text">
											{t('modal_comparador.plan_consultancy.price_text')}
										</span>
									</div>
									<ul className="modal-comparador__plan-list">
										{[1, 2, 3, 4, 5, 6, 7].map((i) => (
											<li
												key={i}
												className="modal-comparador__plan-list-item">
												{t(`modal_comparador.plan_consultancy.list.item${i}`)}
											</li>
										))}
									</ul>
								</div>
							</div>
						</div>
					</div>
				</div>

				<div
					className="modal-comparador__footer"
					dangerouslySetInnerHTML={{ __html: t('modal_comparador.footer.text') }}
				/>
			</div>
		</PopUp>
	);
};

export default ModalComparador;
